(() => {
  if (customElements.get('dod-after-add')) return;
  class AfterAdd extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.copy = JSON.parse(this.querySelector('[data-after-copy]').textContent);
      this.games = new Map([...this.querySelectorAll('[data-after-game]')].map(template => [template.dataset.afterGame, {
        id:template.dataset.afterGame, title:template.dataset.title, variant:Number(template.dataset.variant), price:Number(template.dataset.price), available:template.dataset.available === 'true', template
      }]));
      this.rail = this.querySelector('[data-after-rail]');
      this.addButton = this.querySelector('[data-after-add]');
      this.cartButton = this.querySelector('[data-after-cart]');
      this.error = this.querySelector('[data-after-error]');
      this.family = ['10562206171451','10562206925115','10562204303675','15414764929339','15414762635579'];
      this.date = ['10562205614395','8550716309819','8550720733499','15414755066171','4388068032593'];
      this.party = ['4388068032593','10562202337595','6647592681553','8550722404667','8852198129979','15414769320251','15414777053499'];
      this.querySelector('[data-after-close]').addEventListener('click',()=>this.close());
      this.dialog.addEventListener('cancel',event=>{if(this.busy)event.preventDefault();});
      this.dialog.addEventListener('click',event=>{
        if(event.target!==this.dialog || this.busy)return;
        const r=this.dialog.getBoundingClientRect();
        if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom)this.close();
      });
      this.dialog.addEventListener('close',()=>{
        document.body.classList.remove('dod-after-add-open');
        this.previousFocus?.isConnected && this.previousFocus.focus({preventScroll:true});
      });
      this.querySelectorAll('[data-after-scroll]').forEach(button=>button.addEventListener('click',()=>{
        this.rail.scrollBy({left:Number(button.dataset.afterScroll)*(this.rail.firstElementChild?.getBoundingClientRect().width+10 || 160),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
      this.addButton.addEventListener('click',()=>this.add());
      this.cartButton.addEventListener('click',()=>this.goToCart());
      this.resize = new ResizeObserver(()=>this.fitPacks());
      this.resize.observe(this.dialog);
      window.DODAfterAdd = this;
    }
    disconnectedCallback() { this.resize?.disconnect(); if(window.DODAfterAdd===this)delete window.DODAfterAdd; }
    text(key,values={}) {return (this.copy[key]||'').replace(/__([a-z_]+)__/g,(_,name)=>values[name]??'');}
    money(cents) {return this.formatter.format(cents/100);}
    eligible(item) {return this.games.has(String(item.product_id)) && !item.gift_card && !item.selling_plan_allocation && Number(item.original_price??item.price)>0;}
    count() {return this.cart.items.reduce((sum,item)=>sum+(this.eligible(item)?item.quantity:0),0);}
    async request(path,data) {
      const response=await fetch(this.dataset.root+path,data?{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)}:{headers:{Accept:'application/json'}});
      const result=await response.json();
      if(!response.ok || result.status || result.errors)throw new Error(typeof result.description==='string'?result.description:this.text('unavailable'));
      return result;
    }
    open(cart,drawer,syncing=false) {
      if (window.DODWelcomeGift?.openAfterAdd(cart,drawer,syncing)) {
        this.giftReminder = syncing;
        return true;
      }
      if(this.busy || this.dialog.open || drawer.classList.contains('active') || !window.DODGameTiers || !Array.isArray(cart.items) || cart.item_count===undefined)return false;
      const paid=cart.items.filter(item=>this.eligible(item));
      if(!paid.length)return false;
      if(document.querySelector('dialog[open]'))return false;
      this.drawer=drawer; this.cart=cart; this.pending=[]; this.needsReview=false;
      this.featured=paid.find(item=>Number(item.variant_id)===Number(cart.id))||paid[0];
      this.formatter=new Intl.NumberFormat(this.dataset.locale||'en-US',{style:'currency',currency:cart.currency||this.dataset.currency||'USD'});
      this.prepareCandidates();
      if(!this.candidates.length)return false;
      this.syncing=syncing;this.busy=syncing;
      this.pending=this.candidates.slice(0,Math.max(0,2-this.count())).map(game=>game.id);
      this.previousFocus=drawer.activeElement||document.activeElement;
      this.setError(''); this.querySelector('[data-after-confirm]').textContent=this.text('added');
      this.renderCards(); this.render();
      document.body.classList.add('dod-after-add-open');
      this.dialog.showModal();
      requestAnimationFrame(()=>this.fitPacks());
      return true;
    }
    finishSync(cart,error) {
      if (this.giftReminder) {
        this.giftReminder = false;
        window.DODWelcomeGift?.finishSync(cart,error);
        return;
      }
      if(!this.syncing)return;
      this.syncing=false;this.busy=false;
      if(error){
        this.needsReview=true;
        this.setError(this.text('review'));
      }else{
        const variant=this.featured.variant_id;
        this.cart=cart;
        this.featured=cart.items.find(item=>Number(item.variant_id)===Number(variant))||cart.items.find(item=>this.eligible(item));
        if(!this.featured){this.dialog.close();return;}
        this.prepareCandidates();this.renderCards();
        if(cart.gift_notice)this.setError(cart.gift_notice);
      }
      this.render();
    }
    prepareCandidates() {
      const inCart=new Set(this.cart.items.map(item=>String(item.product_id)));
      const paid=this.cart.items.filter(item=>this.eligible(item));
      const onlyFamily=paid.length>0 && paid.every(item=>this.family.includes(String(item.product_id)));
      const priority=onlyFamily?this.family:this.date.includes(String(this.featured.product_id))?this.date:this.party;
      const rank=id=>priority.includes(id)?priority.indexOf(id):priority.length;
      this.candidates=[...this.games.values()].filter(game=>game.available&&!inCart.has(game.id)&&(!onlyFamily||this.family.includes(game.id))).sort((a,b)=>rank(a.id)-rank(b.id));
      this.pending=this.pending.filter(id=>this.candidates.some(game=>game.id===id));
    }
    makePack(game) {
      const pack=game.template.content.cloneNode(true);
      pack.querySelector('img').sizes='160px';
      return pack;
    }
    fitPacks() {
      this.querySelectorAll('.dod-bundle__pack[data-bounds]').forEach(pack=>{
        if(!pack.clientWidth||!pack.clientHeight)return;
        const image=pack.querySelector('img');
        const [left,top,right,bottom,width,height]=pack.dataset.bounds.split(',').map(Number);
        const scale=Math.min(pack.clientWidth*.97/(right-left),pack.clientHeight*.97/(bottom-top));
        Object.assign(image.style,{width:width*scale+'px',height:height*scale+'px',left:((pack.clientWidth-(right-left)*scale)/2-left*scale)+'px',top:((pack.clientHeight-(bottom-top)*scale)/2-top*scale)+'px'});
      });
    }
    renderCards() {
      this.rail.replaceChildren();
      this.candidates.forEach(game=>{
        const card=document.createElement('label');card.className='dod-after-add__card';card.dataset.gameId=game.id;
        const input=document.createElement('input');input.type='checkbox';input.value=game.id;input.setAttribute('aria-label',game.title);
        const check=document.createElement('span');check.className='dod-after-add__check';check.textContent='✓';check.setAttribute('aria-hidden','true');
        const title=document.createElement('strong');title.className='dod-after-add__game-title';title.textContent=game.title;
        const prices=document.createElement('span');prices.className='dod-after-add__prices';
        const original=document.createElement('s');original.textContent=this.money(game.price);original.setAttribute('aria-label',this.text('original_price'));
        const value=document.createElement('b');value.setAttribute('data-after-price','');value.setAttribute('aria-label',this.text('sale_price'));
        prices.append(original,value);card.append(input,check,this.makePack(game),title,prices);this.rail.append(card);
        input.addEventListener('change',()=>{
          if(this.busy)return;
          if(input.checked&&!this.pending.includes(game.id))this.pending.push(game.id);
          else if(!input.checked)this.pending=this.pending.filter(id=>id!==game.id);
          this.render();
        });
      });
      this.rail.scrollLeft=0;
      requestAnimationFrame(()=>this.fitPacks());
    }
    projection() {
      const count=this.count()+this.pending.length;
      const percent=count>=4?40:count>=2?count*10:0;
      const totals=this.cart.items.reduce((sum,item)=>{
        const base=Number(item.original_line_price??item.price*item.quantity);
        const final=Number(item.final_line_price??base);
        sum.original+=this.eligible(item)?base:final;
        sum.total+=this.eligible(item)?base-Math.floor(base*percent/100):final;
        return sum;
      },{original:0,total:0});
      this.pending.forEach(id=>{const p=this.games.get(id).price;totals.original+=p;totals.total+=p-Math.floor(p*percent/100);});
      if(!this.pending.length){totals.total=Number(this.cart.total_price);totals.original=Math.max(totals.original,totals.total);}
      return {...totals,count,percent};
    }
    render() {
      const totals=this.projection();
      this.querySelectorAll('[data-after-tier]').forEach(step=>{
        const value=Number(step.dataset.afterTier);
        step.classList.toggle('is-active',value===Math.min(totals.count,4));
        step.classList.toggle('is-unlocked',value<Math.min(totals.count,4));
      });
      const included=this.querySelector('[data-after-included]');included.replaceChildren();
      const game=this.games.get(String(this.featured.product_id));
      if(game)included.append(this.makePack(game));
      const copy=document.createElement('div');
      const label=document.createElement('span');label.className='dod-after-add__eyebrow';label.textContent=this.text('already_added',{count:this.count()});
      const title=document.createElement('strong');title.textContent=this.featured.product_title||game?.title||this.featured.title;
      const price=document.createElement('span');price.className='dod-after-add__included-price';
      const old=document.createElement('s');old.textContent=this.money(this.featured.original_line_price);
      const value=document.createElement('b');value.textContent=this.money(this.pending.length?this.featured.original_line_price-Math.floor(this.featured.original_line_price*totals.percent/100):this.featured.final_line_price);
      old.hidden=old.textContent===value.textContent;price.append(old,value);
      copy.append(label,title,price);included.append(copy);
      const tick=document.createElement('span');tick.className='dod-after-add__included-check';tick.textContent='✓';tick.setAttribute('aria-hidden','true');included.append(tick);
      if(this.count()>this.featured.quantity){const others=document.createElement('small');others.textContent=this.text('other_games',{count:this.count()-this.featured.quantity});copy.append(others);}
      this.querySelector('[data-after-instruction]').textContent=!this.candidates.length?this.text('no_more'):totals.percent?this.text('pick_instruction',{percent:totals.percent}):this.text('unlock');
      this.rail.querySelectorAll('[data-game-id]').forEach(card=>{
        const selected=this.pending.includes(card.dataset.gameId);card.classList.toggle('is-selected',selected);
        const input=card.querySelector('input');input.checked=selected;input.disabled=this.busy||this.needsReview;
        const game=this.games.get(card.dataset.gameId);
        const displayPercent=Math.max(20,totals.percent);
        card.querySelector('[data-after-price]').textContent=this.money(game.price-Math.floor(game.price*displayPercent/100));
      });
      this.querySelector('[data-after-selected]').textContent=this.pending.length?this.text('selected',{count:this.pending.length}):this.text('none_selected');
      this.querySelector('[data-after-original]').textContent=this.money(totals.original);
      this.querySelector('[data-after-original]').hidden=totals.original<=totals.total;
      this.querySelector('[data-after-total]').textContent=this.money(totals.total);
      this.querySelector('[data-after-saving]').textContent=this.text('saving',{amount:this.money(Math.max(0,totals.original-totals.total))});
      this.addButton.textContent=this.syncing?this.text('added'):this.busy?this.text('adding'):this.pending.length?this.text(this.pending.length===1?'add_one':'add_many',{count:this.pending.length}):this.text('choose');
      this.addButton.disabled=this.busy||this.needsReview||!this.pending.length;
      this.addButton.hidden=!this.candidates.length;
      this.cartButton.disabled=this.busy;
      this.querySelector('[data-after-close]').disabled=this.busy;
      this.fitPacks();
    }
    setError(message) {this.error.textContent=message;this.error.hidden=!message;}
    close() {if(!this.busy)this.dialog.close();}
    async ensureSections(cart) {
      const sections=this.drawer.getSectionsToRender().map(section=>section.id);
      if(!cart.sections||sections.some(id=>!cart.sections[id]))return this.request('cart/update.js',{sections,sections_url:location.pathname});
      return cart;
    }
    async add() {
      if(this.busy||this.needsReview||!this.pending.length)return;
      this.busy=true;this.setError('');this.render();
      const release=window.DODGameTiers.begin();
      try {
        const latest=await this.request('cart.js');
        const ids=new Set(latest.items.map(item=>String(item.product_id)));
        const chosen=this.pending.filter(id=>!ids.has(id)).map(id=>this.games.get(id)).filter(game=>game?.available);
        if(!chosen.length){this.cart=latest;this.pending=[];this.prepareCandidates();this.renderCards();this.setError(this.text('already_present'));return;}
        const sections=this.drawer.getSectionsToRender().map(section=>section.id);
        let cart=await this.request('cart/add.js',{items:chosen.map(game=>({id:game.variant,quantity:1})),sections,sections_url:location.pathname});
        cart=await window.DODGameTiers.sync(cart,sections);
        cart=await this.ensureSections(cart);
        this.cart=cart;this.pending=[];
        this.featured=cart.items.find(item=>Number(item.variant_id)===chosen[0].variant)||cart.items.find(item=>this.eligible(item));
        this.drawer.classList.remove('is-empty');this.drawer.renderContents(cart,false);
        this.prepareCandidates();this.renderCards();
        this.querySelector('[data-after-confirm]').textContent=this.text('completed',{count:chosen.length});
        if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'dod-after-add',productVariantId:chosen[0].variant,cartData:cart});
        document.dispatchEvent(new CustomEvent('dod:bundle-added',{detail:{count:chosen.length}}));
      }catch(error){
        this.needsReview=true;
        this.setError(this.text('review'));
      }finally{release();this.busy=false;this.render();}
    }
    async goToCart() {
      if(this.busy)return;
      if(this.needsReview){
        this.busy=true;this.render();
        try{const cart=await this.ensureSections(await window.DODGameTiers.sync());this.drawer.renderContents(cart,false);}
        catch(_){location.assign(this.dataset.root+'cart');return;}
        finally{this.busy=false;this.render();}
      }
      this.close();this.drawer.open(this.previousFocus);
    }
  }
  customElements.define('dod-after-add',AfterAdd);
})();

